<template>
  <div class="b">
    <Nav></Nav>
    <div class="titleBox">
      <span class="txt l">mongo库列表</span>
    </div>
    <div class="el-table-box">
      <el-table
        :data="tableData"
        :empty-text="emptyText"
        style="width: 100%"
        :max-height="tableHeight ? tableHeight : 0"
      >
        <el-table-column
          :prop="col.prop"
          :label="col.label"
          :min-width="col.minwidth"
          :width="col.width"
          :fixed="col.fixed"
          :type="col.type"
          show-overflow-tooltip
          v-for="(col, index) in listCol"
          :key="index"
        >
          <!-- <template v-if="col.prop == 'ismaster'" scope="scope">
            {{ scope.row.ismaster ? "主" : "从" }}
          </template> -->
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
import axios from "axios";
import qs from "qs";
export default {
  components: {
    Nav,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      str: "公司后台",
      tableData: [], //列表数据
      emptyText: "",
      tableHeight: "", //表格高度
      listCol: [
        {
          prop: "db",
          label: "库名",
          minwidth: "280",
        },
        {
          prop: "collections",
          label: "表数",
          minwidth: "100",
        },
        {
          prop: "objects",
          label: "记录数",
          minwidth: "100",
        },
        {
          prop: "dataSize",
          label: "数据大小",
          minwidth: "100",
          id: "userId",
        },
        {
          prop: "storageSize",
          label: "存储大小",
          minwidth: "100",
        },
        {
          prop: "indexes",
          label: "索引数",
          minwidth: "100",
        },
        {
          prop: "indexSize",
          label: "索引大小",
          minwidth: "100",
        },
      ],
    };
  },
  mounted() {
    this.getTableHeight();
  },
  methods: {
    getTableHeight() {
      let _this = this;
      let id = _this.$route.query.id
      this.$nextTick(function () {
        this.clientHeight = `${document.documentElement.clientHeight}`;
        this.tableHeight = 500 + "px";
        http.get(apiData.getDataSourceStat, true, { id }, (res) => {
          if(res.data.data){
            res.data.data.list.unshift(res.data.data.total)
            _this.tableData = res.data.data.list
          }
        });
      });
    }
  },

};
</script>
<style scoped lang="less">
.b {
  margin: 0 10px;
}
</style>
